.theme-brand-signnow {
  .related-links-type-1__tags-list-item {
    display: flex;
    align-items: center;
    padding: map-get($spacings, sm) map-get($spacings, 2xl);
    border: map-get($border-widths, sm) solid $color-brand-primary-darkest;
    border-radius: map-get($border-radii, sm);
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
    min-width: 0;
    overflow: hidden;

    &:hover {
      border-color: $color-brand-primary-main;

      .related-links-type-1__link-icon svg {
        fill: $color-brand-primary-main;
      }
    }
  }

  .related-links-type-1__link-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    font-weight: 700;
  }

  .related-links-type-1__link-icon {
    display: inline-flex;
    align-items: center;
    margin-right: map-get($spacings, sm);
    flex-shrink: 0;

    svg {
      fill: $color-brand-primary-darkest;
      transition: fill 0.3s ease;
    }
  }
}
